const initialState = {
    apps: [],
    error: null,
    loading: false,
    success: false,
    assets: []
}

const appsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'APP_CREATE_REQUEST':
            return {
                ...state,
                loading: true,
                success: false,
                error: null
            };
        case 'APP_CREATE_SUCCESS':
            return {
                ...state,
                loading: false,
                success: true,
                error: null
            }
        case 'APP_CREATE_FAIL':
            return {
                ...state,
                loading: false,
                success: false,
                error: true
            }
        case 'GET_APPS':
            return {
                ...state,
                apps: action.payload
            };
        case 'APP_DELETE_SUCCESS':
            return {
                ...state,
                loading: false,
                success: true,
                error: null,
                assets: state.assets.filter(asset => asset._id !== action.payload.id)
            };
        case 'APP_UPDATE_SUCCESS':
            return {
                ...state,
                loading: false,
                success: true,
                error: null,
                assets: state.assets.map(asset =>
                    asset._id === action.payload._id ? action.payload : asset
                )
            };
        default:
            return state;
    }
}

export default appsReducer;